<div class="c-bui-load-more-button__wrapper"
  [ngClass]="[
    'c-bui-load-more-button__wrapper--text-align-' + textAlign,
    disabled ? 'u-disabled' : '',
  ]" (click)="onClick($event)">
  <span class="c-bui-load-more-button">
    <ng-content></ng-content>
  </span>
</div>
